<h1 mat-dialog-title class="title-bar pcps-dialog-title">
    <span class="dialog-title">{{ title }}</span>
</h1>
<mat-dialog-content>
    <div class="dialog-message" [innerHTML]="message"></div>
    <div class="flex flex-col justify-start items-stretch gap-2.5" [formGroup]="loginForm">
        <form novalidate class="flex flex-col justify-start items-stretch gap-3">
            <div class="flex justify-start items-center gap-4 mt-4">
                <span class="basis-1/4 mb-4 text-right">Email:</span>
                <mat-form-field class="grow">
                    <input matInput formControlName="email" placeholder="Email Address" maxlength="150" />
                    <mat-icon matSuffix>person</mat-icon>
                    @if (loginForm.controls.email.errors?.['required']) {
                        <mat-error>Required.</mat-error>
                    } @else if (loginForm.controls.email.errors?.['email']) {
                        <mat-error>Invalid email format.</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="flex justify-start items-center gap-4">
                <span class="basis-1/4 mb-4 text-right">Password:</span>
                <mat-form-field class="grow">
                    <input matInput formControlName="password" placeholder="Password" type="password" (keydown.enter)="OKHandler()" />
                    <mat-icon matSuffix>lock</mat-icon>
                    @if (loginForm.controls.password.errors?.['required']) {
                        <mat-error>Required.</mat-error>
                    }
                </mat-form-field>
            </div>
        </form>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="start">
    <div class="flex flex-col md:flex-row justify-start md:justify-between items-center gap-4 w-full">
        <button mat-flat-button class="tertiary-button" (click)="createAccount()">
            <span>Create New Account</span>
        </button>
        <div class="flex justify-end items-center gap-2">
            <button mat-flat-button class="cancelbtn" [class.cancel-button]="classicCancel" [mat-dialog-close]="null">
                <span>{{ canceltext }}</span>
            </button>
            <button mat-flat-button class="okbtn" (click)="OKHandler()">
                <span>{{ oktext }}</span>
            </button>
        </div>
    </div>
</mat-dialog-actions>
